export const isDelivery = fulfillmentType =>
   ['ONDEMAND_DELIVERY', 'PREORDER_DELIVERY'].includes(fulfillmentType)

export const isPickup = fulfillmentType =>
   ['ONDEMAND_PICKUP', 'PREORDER_PICKUP', 'SCHEDULE_PICKUP'].includes(
      fulfillmentType
   )

export const isDinein = fulfillmentType =>
   ['ONDEMAND_DINEIN', 'PREORDER_DINEIN', 'SCHEDULE_DINEIN'].includes(
      fulfillmentType
   )
